import xss from 'xss';

/**
 * XSS防护工具 - 提供统一的XSS过滤功能
 */

// XSS默认配置
const defaultXssOptions = {
  // 允许的HTML标签和属性白名单
  whiteList: {
    // 保留基本格式标签
    p: ['class', 'style'],
    div: ['class', 'style'],
    span: ['class', 'style'],
    a: ['href', 'title', 'target', 'class', 'style'],
    b: [],
    strong: [],
    i: [],
    em: [],
    br: [],
    code: ['class'],
    pre: ['class'],
    loading: ['content'],
    // 去除所有可能执行JavaScript的标签
    script: [], // 移除所有script标签
    iframe: [], // 移除所有iframe标签
    img: ['src', 'alt', 'title', 'width', 'height', 'class', 'style'], // 仅保留安全属性
  },
  allowList: {
    loading: ['content'],
  },
  // 剥离危险标签而不是替换它们
  stripIgnoreTag: true,
  // 不允许注释标签
  allowCommentTag: false,
  // 过滤不可见字符
  stripBlankChar: true,
  // CSS过滤
  css: false,
};

/**
 * 过滤用户输入，防止XSS攻击
 * @param input 用户输入的字符串
 * @param options 自定义XSS过滤选项
 * @returns 过滤后的安全字符串
 */
export const filterUserInput = (input: string, options = {}): string => {
  if (!input) return input;
  return xss(input);
};

/**
 * 过滤markdown内容，保留更多格式但仍防止XSS攻击
 * @param markdown markdown格式的字符串
 * @returns 过滤后的安全markdown字符串
 */
export const filterMarkdown = (markdown: string): string => {
  if (!markdown) return markdown;
  return xss(markdown, {
    whiteList: {
      loading: ['content'],
    },
  });
};

/**
 * 完全净化HTML，移除所有HTML标签
 * @param html 包含HTML的字符串
 * @returns 移除所有HTML标签后的纯文本
 */
export const stripAllHtml = (html: string): string => {
  if (!html) return html;

  const stripAllOptions = {
    whiteList: {}, // 空白名单 - 不允许任何HTML标签
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script'], // 移除script标签及其内容
  };

  return xss(html, stripAllOptions);
};

/**
 * 用于URL参数的XSS过滤
 * @param url URL字符串
 * @returns 过滤后的安全URL字符串
 */
export const filterUrl = (url: string): string => {
  if (!url) return url;

  // 移除可能包含的JavaScript协议
  if (/^javascript:/i.test(url)) {
    return '';
  }

  // 基本URL过滤
  return stripAllHtml(url);
};

/**
 * 用于原始HTML的严格过滤
 * @param html HTML字符串
 * @returns 过滤后的安全HTML
 */
export const filterHtml = (html: string): string => {
  return xss(html, defaultXssOptions);
};
